// src/lib/x-pixel.ts
/**
 * Pixel do X (Twitter) Ads — id phgqj, conta "Primata das Promo" (2026-10-28).
 *
 * O código base mora no index.html, junto do Pixel da Meta e com a MESMA regra
 * de carga: o twq existe desde o início como fila, e o uwt.js só baixa no
 * bootAnalytics (primeiro toque ou 1,5 s depois do load). Assim nenhum dos dois
 * entra na janela crítica do carregamento.
 *
 * Como o twq já existe como fila, o Lead chamado aqui antes do uwt.js chegar
 * fica guardado e sai quando ele carregar — o clique no CTA abre o grupo em
 * outra aba (window.open), então a página continua aberta para isso.
 */
declare global {
  interface Window {
    twq?: (...args: unknown[]) => void;
  }
}

/** Evento "Lead Generation Tracker" do Gerenciador de eventos do X. */
const EVENTO_LEAD = "tw-phgqj-phgql";

/**
 * Lead no X. `conversion_id` = o mesmo event_id do Lead da Meta: é o campo que o
 * X usa para não contar duas vezes se um dia o lead também for pela API de
 * conversões dele.
 */
export function trackLeadX(eventId: string): void {
  if (typeof window === "undefined" || typeof window.twq !== "function") return;
  try {
    window.twq("event", EVENTO_LEAD, { conversion_id: eventId });
  } catch {
    /* rastreio nunca pode quebrar o clique */
  }
}
